import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

/** Right-side drawer used for version history and long detail views. */
export default function Drawer({ open, onClose, title, subtitle, children, footer, width = 440 }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <>
      <div className="scrim" style={{ display: 'block', padding: 0 }} onMouseDown={onClose} />
      <aside className="drawer-side" style={{ width: `min(${width}px, 100vw)` }} role="dialog" aria-modal="true" aria-label={title}>
        <header className="side-panel__head">
          <div className="stack" style={{ gap: 1, minWidth: 0 }}>
            <strong style={{ fontSize: 'var(--fs-body)' }}>{title}</strong>
            {subtitle && <span className="meta truncate">{subtitle}</span>}
          </div>
          <button type="button" className="modal__close" style={{ marginLeft: 'auto' }} onClick={onClose} aria-label="Close">
            <X size={17} />
          </button>
        </header>
        <div className="side-panel__body">{children}</div>
        {footer && <div className="modal__footer">{footer}</div>}
      </aside>
    </>,
    document.body,
  );
}
